import config from 'react-global-configuration';
import type { AppOptions, SiteDomain } from '../types';
export let APP_ENV = process.env.REACT_APP_ENV;
export const __DEBUG__ = APP_ENV === 'development';
export const USE_SENTRY = process.env.REACT_APP_SENTRY_ENABLED?.toLowerCase() === 'true';
export const SENTRY_DSN = process.env.REACT_APP_SENTRY_DSN;

export const DEFAULT_LANGUAGE = 'nl';
export const LANGUAGE_DUTCH = DEFAULT_LANGUAGE;
export const LANGUAGE_ENGLISH = 'en';
export const MENU_NL = 'main';
export const MENU_EN = 'main-english';
export const SITE_NAME = '<SITE NAME>';
export const APP_ROOT_ELEMENT_ID = 'root';
export let CURRENT_DOMAIN: SiteDomain = 'vluchtelingenwerk';
export const MULTILINGUAL = true;

export const IS_SERVER = !(
  typeof window !== 'undefined'
  && window.document
  && window.document.createElement
);
export const IS_CLIENT = !IS_SERVER;

let API_URL = process.env.REACT_APP_API_URL || "//vluchtelingenwerk.devinc.eu";
// let API_URL = 'http://localhost:3000/api'; // <- For local proxy.

export const FALLBACK_IMAGE = 'https://www.vluchtelingenwerk.nl/sites/default/files/styles/entity_hero_image_desktop/public/2024-01/vwnl-logo-fallback.png';
export const FALLBACK_IMAGE_TEASER = 'https://www.vluchtelingenwerk.nl/sites/default/files/styles/teaser_image_large/public/2024-01/vwnl-logo-fallback.png';

const APOLLO_SEARCH_URL = process.env.REACT_APP_APOLLO_SEARCH_URL || "/apollo/api/graphgl";

// Use config to share static configuration between components and packages.
config.set({
  'SITE_NAME': SITE_NAME,
  'CURRENT_DOMAIN': CURRENT_DOMAIN,
  'MULTILINGUAL': MULTILINGUAL,
  'DEFAULT_LANGUAGE': DEFAULT_LANGUAGE,
  'API_URL': API_URL,
  'APOLLO_SEARCH_URL': APOLLO_SEARCH_URL,
}, { freeze: false });

export let APP_OPTIONS: AppOptions = {
  apiUrl: API_URL,
  element: '',
  parameters: {
    env: APP_ENV,
    blockIdLocationCTABlock: 4,
    blockIdMunicipalityCTABlock: 5,
    links: {
      viewAllProjects: "/nl/wat-wij-doen/projecten",
      footer: {
        anbiURI: '/nl/over-ons/vluchtelingenwerk-nederland-en-anbi',
        postcodeLoterijURI: '/nl/over-ons/de-postcode-loterij-helpt',
        cbfURI: 'https://www.cbf.nl/organisatie/vluchtelingenwerk-nederland',
      }
    }
  }
};

// The value is where the breakpoint starts (mobile-first).
// These values are taken from '/src/src/styles/assets/_variables.scss'.
export const SCREEN_MOBILE = 0; // xs
export const SCREEN_TABLET = 576; // sm
export const SCREEN_NORMAL = 768; // md
export const SCREEN_WIDE = 1200; // lg
export const SCREEN_HUGE = 2000; // xl

// Block ID constants
export const BLOCK_NEWSLETTER_FOOTER_BLOCK_ID = 1;
export const BLOCK_CTA_VACANCY_BLOCK_ID = 2;
export const BLOCK_NEWSLETTER_BLOCK_ID = 3;

// Timeout of the address autocomplete.
export const ADDRESS_AUTOCOMPLETE_TIMEOUT = 550;

export const VACANCY_SEARCH_QUERIES =
  ["vacature", "vacatures", "vacatur", "vacat", "vaca"];

export const VACANCY_OVERVIEW_URL = '/nl/over-ons/stages-bij-vluchtelingenwerk';
export const VACANCY_OVERVIEW_MAP_URL = '/nl/over-ons/stages-bij-vluchtelingenwerk/kaart';

export const NL_LOCATIONS_URL = 'locaties';
export const EN_LOCATIONS_URL = 'locations';
export const NL_NEWS_KNOWLEDGE_URL = 'nieuws-en-kennis'
export const EN_NEWS_KNOWLEDGE_URL = 'news-and-frequently-asked-questions'
export const NL_THEMES_URL = 'onze-themas';
export const EN_THEMES_URL = 'our-themes';
export const locationsUrl = (language = 'nl') => {
  const isEnglish = language === 'en';
  return `/${language}/${isEnglish ? EN_LOCATIONS_URL : NL_LOCATIONS_URL}`;
};
export const SELECTED_ENTITIES_SIZE_SMALL = 3;
export const SELECTED_ENTITIES_SIZE_LARGE = 4;

export const FILTER_ID_TYPE_VACANCY = 'type_vacancy';

export const NOT_FOUND_LINKS = {
  faq: 'node/26779',
  contact: 'node/19637'
};

export const BREADCRUMB_URLS = {
  projects: {
    nl: {
      what_we_do: "/nl/wat-wij-doen",
      overview: "/nl/wat-wij-doen/projecten"
    },
    en: {
      what_we_do: "/en/our-work",
      overview: "/en/our-work/projects"
    }
  },
  vacancies: {
    nl: {
      about_us: "/nl/over-ons",
      overview: "/nl/over-ons/stages-bij-vluchtelingenwerk"
    },
    en: {
      what_we_do: "/en/about-us",
      overview: "/en/about-us/internships-at-refugee-work"
    }
  },
  points_of_view: {
    nl: {
      about_us: "/nl/over-ons",
      overview: "/nl/over-ons/onze-standpunten"
    },
    en: {
      what_we_do: "/en/about-us",
      overview: "/en/about-us/our-points-of-view"
    }
  }
}

export const HTTP_CODE_NOT_FOUND = 404;
export const HTTP_CODE_GONE = 410;


export function saveConstants(options: AppOptions) {
  APP_OPTIONS = options;

  if (options.parameters.env) {
    APP_ENV = options.parameters.env;
  }

  if (options.apiUrl) {
    API_URL = options.apiUrl;
  }

  // Update the config.
  config.set({
    'SITE_NAME': SITE_NAME,
    'CURRENT_DOMAIN': CURRENT_DOMAIN,
    'MULTILINGUAL': MULTILINGUAL,
    'DEFAULT_LANGUAGE': DEFAULT_LANGUAGE,
    'API_URL': API_URL,
    'APOLLO_SEARCH_URL': APOLLO_SEARCH_URL,
  });
}
